import React, {ReactElement} from "react"

const RouteIcon = (): ReactElement => {
	return (
    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.75 11.1244C18.2818 11.8188 20.75 13.4047 20.75 15.25C20.75 17.7353 16.2728 19.75 10.75 19.75C5.22715 19.75 0.75 17.7353 0.75 15.25C0.75 13.4047 3.21819 11.8188 6.75 11.1244M10.75 14.75V0.75L16.0677 4.02244C16.4556 4.26114 16.6495 4.38049 16.7114 4.53085C16.7654 4.662 16.7611 4.8099 16.6997 4.93771C16.6292 5.08426 16.4287 5.19222 16.0277 5.40815L10.75 8.25"
        stroke="#17253C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default RouteIcon
